import React from 'react'
import { Link } from 'react-router-dom';
import { DiscoverButton } from './../../index';
import './ProductCard.css';

const ProductCard = ({img, title, url, onClick }) => {
let imgSrc = '';
try{
  imgSrc = require('./../../../assets/img/'+img+'.jpg').default;
}catch{
  imgSrc = undefined;
}

  return(
    <Link to={url} className="productCard" onClick={onClick}>
      <div className="card">
        {imgSrc === undefined ? '' : <img className="imgProduct" src={imgSrc} alt={img} onError={(e) => e.target.src = null} /> }
        
         {/* {checkImg(img)} */}
        <p className="pTitle">{title}</p>
        <DiscoverButton />
      </div>
    </Link>
  )
}

export default ProductCard;